import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';

var ButtonGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ButtonGroup, _React$PureComponent);

  var _super = _createSuper(ButtonGroup);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _super.apply(this, arguments);
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: 'btn-group ' + this.props.className,
        role: 'group'
      }, this.props.children);
    }
  }]);

  return ButtonGroup;
}(React.PureComponent);

export default ButtonGroup;